<template>
  <modal :show.sync="isOpen" :show-close="false" size="lg" :headerClasses="{ 'flex justify-end': isArabic }">
    <!-- Loading overlay -->
    <div v-if="isSaving" class="absolute inset-0 z-50 flex items-center justify-center bg-white bg-opacity-70">
      <svg class="animate-spin h-10 w-10 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
      </svg>
    </div>

    <template slot="header">
      <h6 id="tiers.modaltitle" class="modal-title">{{ syncedTier ? translate("Edit Tier") : translate("New Tier") }}
      </h6>
    </template>

    <form id="tiers.modalform" ref="form" slot="default" class="w-full grid gap-4"
      :class="{ 'pointer-events-none opacity-60': isSaving }">
      <!-- Name -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div :class="isArabic ? 'flex-row-reverse' : ''">
          <div :class="isArabic ? 'justify-end flex' : ''">
            <!-- <label>
              {{ translate('Name - _LANG_', { '_LANG_': translate(getConceptSettings.attributes['primary-language']) })}}
            </label> -->
            <label>
              {{ translate("Name - English") }}
            </label>
          </div>
          <!-- <BaseField v-model="form.name[getConceptSettings.attributes['primary-language']]" :required="true"
            :placeholder="translate('Name')" @valid="schemaValid.name = $event" :error="!schemaValid.name"
            :disabled="isSaving" /> -->
          <BaseField id="tiers.modalformnamearabic" v-model="form.name['en-us']" :required="true"
            :placeholder="translate('Name')" @valid="schemaValid.name = $event" :error="!schemaValid.name"
            :error-message="translate('Name is required')" :disabled="isSaving" />
        </div>
        <div v-if="getConceptSettings.attributes['secondary-language']" :class="isArabic ? 'flex-row-reverse' : ''">
          <div :class="isArabic ? 'justify-end flex' : ''">
            <!-- <label>
              {{ translate('Name - _LANG_', {
                '_LANG_': translate(getConceptSettings.attributes['secondary-language'])
              }) }}
            </label> -->
            <label>
              {{ translate("Name - Arabic") }}
            </label>
          </div>
          <!-- <BaseField v-model="form.name[getConceptSettings.attributes['secondary-language']]" :required="true"
            :placeholder="translate('Name')" :error="!schemaValid.name" @valid="schemaValid.name = $event"
            :error-message="translate('Name is required')" :disabled="isSaving" /> -->
          <BaseField id="tiers.modalformnameenglish" v-model="form.name['ar-sa']" :required="true"
            :placeholder="translate('Name')" @valid="schemaValid.name = $event" :error="!schemaValid.name"
            :error-message="translate('Name is required')" :disabled="isSaving" />
        </div>
      </div>
      <!-- Start Point -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div :class="isArabic ? 'flex-row-reverse' : ''">
          <div :class="isArabic ? 'justify-end flex' : ''">
            <label>{{ translate('Start Point') }}</label>
          </div>
          <BaseField id="tiers.modalformstartpoint" v-model="form['start-point']" input-type="number" :required="true"
            :placeholder="translate('Start Point')" :error="!schemaValid.startPoint"
            @valid="schemaValid.startPoint = $event" :error-message="translate('Start Point is required')"
            :disabled="isSaving" />
        </div>
        <div :class="isArabic ? 'flex-row-reverse' : ''">
          <div :class="isArabic ? 'justify-end flex' : ''">
            <label>{{ translate('End Point') }}</label>
          </div>
          <BaseField id="tiers.modalformendpoint" v-model="form['end-point']" input-type="number" :required="true"
            :placeholder="translate('End Point')" :error="!schemaValid.endPoint" @valid="schemaValid.endPoint = $event"
            :error-message="translate('End Point is required')" :disabled="isSaving" />
        </div>
      </div>
      <!-- Collect Point -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div :class="isArabic ? 'flex-row-reverse' : ''">
          <div :class="isArabic ? 'justify-end flex' : ''">
            <label>{{ translate('Collect Point') }}</label>
          </div>
          <BaseField id="tiers.modalformcollectpoint" v-model="form['collect-rules']['earn-point']" input-type="number"
            :placeholder="translate('Collect Point')" :error="!schemaValid.collectPoint"
            @valid="schemaValid.collectPoint = $event" :error-message="translate('Collect Point is required')"
            :disabled="isSaving" />
        </div>
        <div :class="isArabic ? 'flex-row-reverse' : ''">
          <div :class="isArabic ? 'justify-end flex' : ''">
            <label>{{ translate(`Per`) }}
              <display-currency>{{ getConceptSettings.attributes['currency-code'] }}</display-currency>
            </label>
          </div>
          <BaseField id="tiers.modalformcollectpointsar" v-model="form['collect-rules']['per-sar']" input-type="number"
            :placeholder="translate('Per') + ' ' + getConceptSettings.attributes['currency-code']"
            :error="!schemaValid.collectPoint" @valid="schemaValid.collectPoint = $event"
            :error-message="translate('Collect Point is required')" :disabled="isSaving" />
        </div>
      </div>
      <!-- Redeem Point -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div :class="isArabic ? 'flex-row-reverse' : ''">
          <div :class="isArabic ? 'justify-end flex' : ''">
            <label>{{ translate(`Redeem`) }}
              <display-currency>{{ getConceptSettings.attributes['currency-code'] }}</display-currency>
            </label>
          </div>
          <BaseField id="tiers.modalformredeempointsar" v-model="form['redeem-rules']['earn-sar']" input-type="number"
            :placeholder="translate('Redeem') + ' ' + $displayCurrency(getConceptSettings.attributes['currency-code'])"
            :error="!schemaValid.redeemPoint" @valid="schemaValid.redeemPoint = $event"
            :error-message="translate('Redeem Point is required')" :disabled="isSaving" />
        </div>
        <div :class="isArabic ? 'flex-row-reverse' : ''">
          <div :class="isArabic ? 'justify-end flex' : ''">
            <label>{{ translate('Per Point') }}</label>
          </div>
          <BaseField id="tiers.modalformredeempoint" v-model="form['redeem-rules']['per-point']" input-type="number"
            :placeholder="translate('Per Point')" :error="!schemaValid.redeemPoint"
            @valid="schemaValid.redeemPoint = $event" :error-message="translate('Redeem Point is required')"
            :disabled="isSaving" />
        </div>
      </div>
      <!-- Image -->
      <div class="mt-4">
        <!-- Image Type -->
        <div class="flex flex-col md:flex-row gap-4">
          <div class="flex-1 min-w-0">
            <div :class="['form-control-label', isArabic ? 'flex justify-end' : '']">
              <label>{{ translate('Image Type') }}</label>
            </div>
            <BaseField id="tiers.modalformimagetype" v-model="selectedType" type="select"
              :options="imageTypes.map(type => ({ value: type.value, label: type.text }))"
              :placeholder="translate('Select an option')" :error="!schemaValid.imageType"
              @valid="schemaValid.imageType = $event" :error-message="translate('Image Type is required')"
              :disabled="isSaving" />
          </div>
          <div v-if="selectedType === 0" class="flex-1 min-w-0 ">
            <label class="text-sm font-semibold">{{ translate('Upload Image') }}</label>
            <div class="flex flex-col gap-2">
              <V2BaseFileInput id="tiers.modalformimageupload" v-model="fileValue" :error-message="fileError"
                :max-size-m-b="2" accept="image/*" @error="fileError = $event" @input="fileError = ''"
                :placeholder="translate('Click or drag an image here to upload')" :disabled="isSaving" />
              <span v-if="fileError" class="text-red-500 text-xs">{{ fileError }}</span>
            </div>
          </div>
          <div v-if="selectedType === 1" class="flex-1 min-w-0 ">
            <label class="text-sm font-semibold">{{ translate('Image URL') }}</label>
            <BaseField id="tiers.modalformimageurl" v-model="imageUri" name="image-uri"
              :placeholder="translate('Image URL')" :error="!schemaValid.imageUrl"
              @valid="schemaValid.imageUrl = $event" :error-message="translate('Image URL is required')"
              :disabled="isSaving" />
          </div>
          <div v-if="selectedType === 2" class="flex-1 min-w-0 ">
            <label class="text-sm font-semibold">{{ translate('Image URL') }}</label>
            <BaseField id="tiers.modalformimageurl" v-model="imageUri" name="image-uri"
              :placeholder="translate('Image URL')" :error="!schemaValid.imageUrl"
              @valid="schemaValid.imageUrl = $event" :error-message="translate('Image URL is required')" />
          </div>
        </div>
        <!-- Stock Images -->
        <div v-if="selectedType === 2" class="mt-4">
          <div class="flex flex-col md:flex-row gap-2 items-center">
            <div class="flex-1 min-w-0">
              <BaseField id="tiers.modalformsearchstock" type="input" v-model="searchStock"
                :placeholder="translate('Search by keyword')" class="w-full" :error="!schemaValid.imageUrl"
                @valid="schemaValid.imageUrl = $event" :error-message="translate('Image URL is required')"
                :disabled="isSaving" />
            </div>
            <div class="flex-none flex justify-end">
              <v2-base-button id="tiers.modalformsearchstockbutton" block type="primary" @click="searchStockImages"
                :disabled="isSaving">
                {{ translate('SEARCH') }}
              </v2-base-button>
            </div>
          </div>
        </div>
        <!-- Stock Images List -->
        <div v-if="selectedType === 2" class="mt-4">
          <div class="flex flex-wrap gap-2">
            <div v-for="stockImage in stockImages" :key="stockImage.id">
              <img :src="stockImage.attributes['image-uri']" width="150" height="150"
                class="m-1 cursor-pointer border rounded"
                :class="stockImage.attributes['image-uri'] === imageUri ? 'ring-2 ring-primary' : ''"
                @click="selectStockImage(stockImage.attributes['image-uri'])" />
            </div>
          </div>
        </div>
        <!-- Uploaded Image -->
        <div class="px-2 mt-4" v-if="syncedTier && form['image-url']">
          <div>
            <label class="text-sm font-semibold">{{ translate('Uploaded Image') }}</label>
          </div>
          <div>
            <img :src="form['image-url']" width="150" height="150" class="my-1" />
          </div>
        </div>
      </div>
    </form>

    <template slot="footer">
      <v2-base-button id="tiers.modalsavebutton" variant="success" :disabled="isSaving" @click="onSave">
        <svg v-if="isSaving" class="animate-spin h-5 w-5 mr-2 inline-block text-white"
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
        {{ syncedTier ? translate("Update") : translate("Save") }}
      </v2-base-button>
      <v2-base-button id="tiers.modalclosebutton" variant="default" class="ml-auto" @click="closeModal"
        :disabled="isSaving">
        {{ translate("Close") }}
      </v2-base-button>
    </template>
  </modal>
</template>

<script>
import _ from 'lodash';
import Translations from '@/mixins/translations';
import { Loyalty as LoyaltyService, Category } from '@/services/SOLO';
import { mapGetters } from 'vuex';
import V2BaseButton from '@/components/V2/V2BaseButton.vue';
import BaseField from '@/components/V2/BaseField.vue';
import V2BaseFileInput from '@/components/V2/V2BaseFileInput.vue';

export default {
  name: 'TierSingleModal',
  mixins: [Translations],
  components: {
    V2BaseButton,
    BaseField,
    V2BaseFileInput,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tier: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      schemaValid: this.getDefaultSchemaValid(),
      form: this.getDefaultForm(),
      selectedType: 2,
      imageTypes: [
        { value: 0, text: 'Upload IMG' },
        { value: 1, text: 'Image URL' },
        { value: 2, text: 'Stock Images' },
      ],
      fileValue: null,
      imageUri: '',
      searchStock: 'Loyalty Card',
      stockImages: [],
      isSaving: false,
      fileError: '',
    };
  },
  computed: {
    ...mapGetters({
      getConceptSettings: 'account/getConceptSettings',
      getLocale: 'app/getLocale',
    }),
    isArabic () {
      return this.getLocale === 'ar_SA';
    },
    isOpen: {
      get () {
        return this.value;
      },
      set (val) {
        this.stockImages = [];
        this.$emit('input', val);
      },
    },
    syncedTier: {
      get () {
        return this.tier;
      },
      set (val) {
        this.$emit('update:tier', val);
      },
    },
  },
  watch: {
    tier: {
      handler (newVal) {
        if (newVal) {
          this.populateFormFromTier(newVal);
        } else {
          this.resetForm();
        }
      },
      immediate: true,
    },
    selectedType (val) {
      if (val === 2) {
        this.searchStock = 'Loyalty Card';
      }
      this.stockImages = [];
    },
  },
  methods: {
    // --- Default State Helpers ---
    getDefaultForm () {
      return {
        name: {
          'en-us': '',
          'ar-sa': '',
        },
        'start-point': 0,
        'end-point': 0,
        'collect-rules': {
          'earn-point': 0,
          'per-sar': 0,
        },
        'redeem-rules': {
          'earn-sar': 0,
          'per-point': 0,
        },
        color: '',
        'image-url': '',
      };
    },
    getDefaultSchemaValid () {
      return {
        name: true,
        startPoint: true,
        endPoint: true,
        collectPoint: true,
        redeemPoint: true,
        imageType: true,
        imageUrl: true,
        stockImages: true,
      };
    },

    // --- Form Population ---
    populateFormFromTier (tier) {
      this.fileValue = null;
      this.imageUri = tier['image-url'] || '';
      this.imageTypes = [
        { value: 0, text: 'Upload IMG' },
        { value: 1, text: 'Image URL' },
        { value: 2, text: 'Stock Images' },
      ];
      if (tier['image-type']) {
        if (tier['image-type'] === 'Upload IMG') {
          this.selectedType = 0;
        } else if (tier['image-type'] === 'Image URL') {
          this.selectedType = 1;
        } else if (tier['image-type'] === 'Stock Images') {
          this.selectedType = 2;
          if (tier['image-url']) {
            this.imageUri = tier['image-url'];
            this.stockImages = [...this.stockImages, { attributes: { 'image-uri': tier['image-url'] } }];
          }
        }
      }
      // Deep copy tier fields into form
      for (const key in tier) {
        if (typeof this.form[key] !== 'undefined') {
          this.form[key] = _.cloneDeep(tier[key]);
        }
      }
    },

    // --- Stock Image Logic ---
    selectStockImage (stockImage) {
      this.imageUri = stockImage;
    },
    async searchStockImages () {
      try {
        const searchFilter = this.searchStock.toLowerCase();
        const images = await Category.searchStockImgs(searchFilter);
        this.stockImages = images.data.data;
        if (!this.stockImages || this.stockImages.length === 0) {
          this.imageUri = '';
        }
      } catch (error) {
        console.error('error', error);
      }
    },

    // --- Form Validation ---
    isFormValid () {
      return (
        this.schemaValid.name &&
        this.schemaValid.startPoint &&
        this.schemaValid.endPoint &&
        this.schemaValid.collectPoint &&
        this.schemaValid.redeemPoint &&
        this.schemaValid.imageType &&
        this.schemaValid.imageUrl
      );
    },

    // --- Notification Helper ---
    notify ({ title, message, type }) {
      this.$notify({
        title,
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message,
        type,
      });
    },

    // --- FormData Builder ---
    buildFormData (isUpdate = false) {
      const formData = new FormData();
      const appendField = (key, value) => formData.append(key, value ?? '');
      appendField('name[en-us]', this.form.name['en-us']);
      appendField('name[ar-sa]', this.form.name['ar-sa']);
      appendField('color', this.form.color);
      appendField('start-point', this.form['start-point']);
      appendField('end-point', this.form['end-point']);
      appendField('collect-rules[earn-point]', this.form['collect-rules']['earn-point']);
      appendField('collect-rules[per-sar]', this.form['collect-rules']['per-sar']);
      appendField('redeem-rules[earn-sar]', this.form['redeem-rules']['earn-sar']);
      appendField('redeem-rules[per-point]', this.form['redeem-rules']['per-point']);
      if (this.fileValue) {
        appendField('image', this.fileValue);
      } else {
        appendField('image-url', this.imageUri);
        const imageType = this.imageTypes.find((type) => type.value === this.selectedType);
        appendField('image-type', imageType ? imageType.text : '');
      }
      if (isUpdate) {
        appendField('_method', 'put');
      }
      return formData;
    },

    // --- API Calls ---
    async onSave () {
      if (!this.isFormValid()) {
        this.notify({
          title: 'CREATE DATA',
          message: 'Please fill all the required fields!',
          type: 'danger',
        });
        return;
      }
      this.isSaving = true;
      try {
        if (this.tier) {
          await this.handleUpdateTier();
        } else {
          await this.handleCreateTier();
        }
        this.closeModal();
        this.resetForm();
      } finally {
        this.isSaving = false;
      }
    },
    async handleCreateTier () {
      try {
        const formData = this.buildFormData(false);
        const { data } = await LoyaltyService.createTier(formData);
        data.data.name = this.form.name;
        this.$emit('add:tier', data.data);
        this.notify({
          title: 'CREATE DATA',
          message: 'Tier was created successfully!',
          type: 'success',
        });
        this.$emit('tiers-changed');
      } catch (error) {
        console.log('Error in Creation of Tier', error);
        this.notify({
          title: 'CREATE DATA',
          message: 'Error in Creation of Tier!',
          type: 'danger',
        });
      }
    },
    async handleUpdateTier () {
      try {
        const formData = this.buildFormData(true);
        const { data } = await LoyaltyService.updateTier(this.tier.id, formData);
        data.data.name = this.form.name;
        this.form['image-url'] = data.data['image-url'];
        this.$emit('update:tier', data.data);
        // Sync form with updated tier
        for (const key in this.form) {
          if (typeof this.tier[key] !== 'undefined') {
            this.tier[key] = this.form[key];
          }
        }
        this.notify({
          title: 'UPDATE DATA',
          message: 'Tier data was updated successfully!',
          type: 'success',
        });
        this.$emit('tiers-changed');
      } catch (error) {
        console.log('Error in Updating of Tier', error);
        this.notify({
          title: 'UPDATE DATA',
          message: 'Error in Updating of Tier!',
          type: 'danger',
        });
      }
    },

    // --- Form Reset ---
    resetForm () {
      this.form = this.getDefaultForm();
      this.schemaValid = this.getDefaultSchemaValid();
      this.selectedType = 0;
      this.fileValue = null;
      this.imageUri = '';
      this.fileError = '';
      this.stockImages = [];
    },
    closeModal () {
      this.isOpen = false;
    },
  },
};
</script>
